// lib
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

// components
import Popup from '@aytm/lib/rfd-ui/components/basic/popup'

import { default as ComponentContainer } from '@aytm/app/stats/page/question-views/components/questions-custom/Component'

import { pressable } from '@aytm/app/stats/components/lib/pressable'

// styles
import style from '@aytm/app/stats/page/question-views/components/questions-mapping/styles/Component.module.scss'

export const DataContext = React.createContext()

const Component = ({
  Controls,
  Footer,
  children,
  model,
  data,
  states,
  prefix,
  command,
  changed,
  disabled,
  dataContextValue,
  onFeaturesChange,
  onControlsChange,
  onUpdateData,
  ...rest
}) => {
  const showMapping = useMemo(
    () =>
      (model.features == undefined || !model.features.insightsMapping) &&
      !model.disabled &&
      'function' == typeof onFeaturesChange,
    [model.features, model.disabled, onFeaturesChange]
  )

  return (
    <ComponentContainer
      Controls={Controls}
      model={model}
      data={data}
      states={states}
      changed={changed}
      disabled={disabled}
      onChange={onControlsChange}
    >
      <div className={style.component}>
        {showMapping ? (
          <div className={`${style.row} ${style['row-toggle']}`}>
            <div className="p-right p-col">
              <span className={style.toggle} {...pressable(() => onFeaturesChange('insightsMapping', true))}>
                Convert to {prefix} Mapping
              </span>
            </div>
            <div className="p-right">
              <Popup
                width="500px"
                trigger="click"
                direction="bottomright"
                popupOffset={9}
                hideOtherPopupsOnShow
                content={() => (
                  <div>
                    Convert this {prefix} Lab into a {prefix} Mapping to send the data to the Insights Portal.
                  </div>
                )}
              >
                <i className="icon-aytmfd-help-v2" />
              </Popup>
            </div>
          </div>
        ) : null}
        <DataContext.Provider value={dataContextValue}>{children}</DataContext.Provider>
      </div>
      {!disabled && (
        <Footer
          model={model}
          data={data}
          states={states}
          prefix={prefix}
          command={command}
          updateTextPrefix={states.loading ? 'Running' : 'Run'}
          onChange={onControlsChange}
          onUpdateData={onUpdateData}
          {...rest}
        />
      )}
    </ComponentContainer>
  )
}

Component.propTypes = {
  Controls: PropTypes.any,
  Footer: PropTypes.any,
  children: PropTypes.any,
  model: PropTypes.object,
  data: PropTypes.object,
  states: PropTypes.object,
  prefix: PropTypes.string,
  command: PropTypes.string,
  changed: PropTypes.bool,
  disabled: PropTypes.bool,
  dataContextValue: PropTypes.any,
  onControlsChange: PropTypes.func,
  onUpdateData: PropTypes.func,
  onFetchApiKey: PropTypes.func,
  onPublish: PropTypes.func,
  onPublished: PropTypes.func,
  onFeaturesChange: PropTypes.func
}

Component.displayName = 'Component'

export default Component
